export const services = [
  {
    "slug": "website-design-redesign",
    "name": "Nonprofit Website Design & Redesign",
    "benefit": "Make your mission easy to understand.",
    "description": "Clear, welcoming websites that help people find programs, understand your work, and take the next step.",
    "icon": "01",
    "category": "reach",
    "details": "Website structure, messaging, copywriting, design, and development in WordPress, Webflow, or a custom site with a CMS such as Sanity. Program pages, volunteer inquiries, event registrations, donation-platform connections, accessibility improvements, and measurement are selected during scoping. Your team approves the work and owns the site.",
    "seoTitle": "Nonprofit Website Design & Redesign | Hudson Valley",
    "seoDescription": "Nonprofit website design and redesign with copywriting, program pages, forms, CMS development, and scoped integrations. Hudson Valley, NYC, and remote.",
    "question": "What is included in a nonprofit website redesign?",
    "answer": "A nonprofit website redesign can include audience and page planning, copywriting, visual design, CMS development, program pages, and agreed forms and integrations. The scope should also define accessibility testing, URL redirects, content approvals, and staff handoff.",
    "faqs": [
      [
        "Who is this service for?",
        "Community-serving nonprofits with an active mission and a staff team that needs focused communications or technology support. We assess fit around your programs, priorities, team capacity, and budget."
      ],
      [
        "How are fees and timing agreed?",
        "A free discovery call and no-charge assessment help define the work. We agree deliverables, responsibilities, fees, and timing before the engagement starts. The number of audiences, content needs, integrations, and review steps can affect the scope."
      ],
      [
        "Can you work with our existing team and tools?",
        "Yes. We review what your team already uses before recommending changes. Platforms, permissions, staff responsibilities, and any handoff or training are agreed during scoping."
      ],
      [
        "Do you work with nonprofits outside the Hudson Valley?",
        "Yes. Sync Strategic is based in Orange County, NY and serves the Hudson Valley, NYC, and beyond. Remote collaboration is available for organizations outside the region."
      ]
    ],
    "deliverables": []
  },
  {
    "slug": "inbound-outbound-campaigns",
    "name": "Communications & Campaigns",
    "benefit": "Reach your community with purpose.",
    "description": "Focused campaigns for program awareness, volunteer recruitment, community engagement, and fundraising communications.",
    "icon": "02",
    "category": "reach",
    "details": "Audience planning, campaign messaging, copy and creative, email, search visibility, and agreed paid channels such as Google Ads and Meta Ads. Fundraising communications can support your development team\u2019s strategy. Grant writing, major-gift strategy, and fundraising management are outside this offer. Clients approve campaign materials and pay media platforms directly.",
    "seoTitle": "Nonprofit Communications & Marketing Campaigns",
    "seoDescription": "Nonprofit communications and marketing campaigns for program awareness, volunteer recruitment, and supporter engagement. Strategy, content, email, and measurement.",
    "question": "How can a communications campaign support a nonprofit?",
    "answer": "A nonprofit communications campaign connects a specific audience to a clear action, such as learning about a program, applying to volunteer, registering for an event, or responding to an appeal. We bring the message, creative, landing page, channels, and measurement together.",
    "faqs": [
      [
        "Who is this service for?",
        "Community-serving nonprofits with an active mission and a staff team that needs focused communications or technology support. We assess fit around your programs, priorities, team capacity, and budget."
      ],
      [
        "How are fees and timing agreed?",
        "A free discovery call and no-charge assessment help define the work. We agree deliverables, responsibilities, fees, and timing before the engagement starts. The number of audiences, content needs, integrations, and review steps can affect the scope."
      ],
      [
        "Can you work with our existing team and tools?",
        "Yes. We review what your team already uses before recommending changes. Platforms, permissions, staff responsibilities, and any handoff or training are agreed during scoping."
      ],
      [
        "Do you work with nonprofits outside the Hudson Valley?",
        "Yes. Sync Strategic is based in Orange County, NY and serves the Hudson Valley, NYC, and beyond. Remote collaboration is available for organizations outside the region."
      ]
    ],
    "deliverables": [
      "A defined audience, message, and action for the campaign",
      "Agreed email, creative, landing-page, and channel materials",
      "A launch and approval plan with responsibility for responses",
      "Tracking and progress reviews tied to the agreed action"
    ]
  },
  {
    "slug": "crm-setup",
    "name": "CRM & Relationship Management",
    "benefit": "Keep the people behind your mission connected.",
    "description": "Organize contacts, connect forms, and build useful follow-up for supporters, volunteers, partners, and program inquiries.",
    "icon": "03",
    "category": "systems",
    "details": "Contact structure, segmentation, data cleanup and migration, forms, routing, email workflows, dashboards, and team training. Salesforce, HubSpot, and Freshworks are assessed against your requirements. Specialized donor management, gift accounting, and program case-management requirements are assessed separately before any implementation is agreed.",
    "seoTitle": "Nonprofit CRM Setup & Relationship Management",
    "seoDescription": "Nonprofit CRM consulting and setup for contact organization, volunteer inquiries, supporter follow-up, forms, migration, and team training.",
    "question": "What does nonprofit CRM setup involve?",
    "answer": "Nonprofit CRM setup organizes contact data and the workflows around it. We assess fields, segmentation, duplicate records, forms, ownership, follow-up, permissions, reporting, and training. Donation processing, gift accounting, and confidential case management are separate requirements to evaluate.",
    "faqs": [
      [
        "Who is this service for?",
        "Community-serving nonprofits with an active mission and a staff team that needs focused communications or technology support. We assess fit around your programs, priorities, team capacity, and budget."
      ],
      [
        "How are fees and timing agreed?",
        "A free discovery call and no-charge assessment help define the work. We agree deliverables, responsibilities, fees, and timing before the engagement starts. The number of audiences, content needs, integrations, and review steps can affect the scope."
      ],
      [
        "Can you work with our existing team and tools?",
        "Yes. We review what your team already uses before recommending changes. Platforms, permissions, staff responsibilities, and any handoff or training are agreed during scoping."
      ],
      [
        "Do you work with nonprofits outside the Hudson Valley?",
        "Yes. Sync Strategic is based in Orange County, NY and serves the Hudson Valley, NYC, and beyond. Remote collaboration is available for organizations outside the region."
      ]
    ],
    "deliverables": [
      "A relationship and data map for your key contact types",
      "Agreed fields, segmentation, permissions, and migration mappings",
      "Selected forms, routing, and follow-up workflows",
      "Dashboards, documentation, and staff training in scope"
    ]
  },
  {
    "slug": "marketing-strategy",
    "name": "Marketing & Communications Strategy",
    "benefit": "Give your team a clear direction.",
    "description": "Clarify who you need to reach, what they need to hear, and where your time and budget can make a difference.",
    "category": "story",
    "details": "Audience research, positioning, messaging, channel priorities, and an actionable communications plan. Goals can include program participation, community awareness, volunteer recruitment, and supporter engagement. The no-charge sales assessment defines the engagement; the strategy is delivered as scoped work.",
    "seoTitle": "Nonprofit Marketing & Communications Planning",
    "seoDescription": "Nonprofit marketing strategy and communications planning. Define audiences, messages, channels, priorities, and measures around your mission and team capacity.",
    "question": "What should a nonprofit communications strategy include?",
    "answer": "A nonprofit communications strategy should identify the organizational priority, the audiences involved, the message for each audience, the action to encourage, and the channels and staff responsible. We turn these decisions into a practical plan with agreed measures and a realistic delivery cadence.",
    "faqs": [
      [
        "Who is this service for?",
        "Community-serving nonprofits with an active mission and a staff team that needs focused communications or technology support. We assess fit around your programs, priorities, team capacity, and budget."
      ],
      [
        "How are fees and timing agreed?",
        "A free discovery call and no-charge assessment help define the work. We agree deliverables, responsibilities, fees, and timing before the engagement starts. The number of audiences, content needs, integrations, and review steps can affect the scope."
      ],
      [
        "Can you work with our existing team and tools?",
        "Yes. We review what your team already uses before recommending changes. Platforms, permissions, staff responsibilities, and any handoff or training are agreed during scoping."
      ],
      [
        "Do you work with nonprofits outside the Hudson Valley?",
        "Yes. Sync Strategic is based in Orange County, NY and serves the Hudson Valley, NYC, and beyond. Remote collaboration is available for organizations outside the region."
      ]
    ],
    "deliverables": [
      "An audience and communications priorities brief",
      "Shared positioning and audience-specific messages",
      "Channel recommendations and a practical delivery calendar",
      "An ownership, approval, and measurement plan"
    ]
  },
  {
    "slug": "branding-rebranding",
    "name": "Nonprofit Branding & Messaging",
    "benefit": "Express what your mission makes possible.",
    "description": "A clear identity and shared message for the people you serve, the people who support you, and your team.",
    "category": "story",
    "details": "Positioning, audience-specific messaging, naming where needed, visual identity, brand guidelines, and rollout materials. We help explain your mission and programs clearly across your website, presentations, email, and print. Deliverables are agreed in scope; trademark review and registration are handled separately through referral.",
    "seoTitle": "Nonprofit Branding, Rebranding & Messaging",
    "seoDescription": "Nonprofit branding and rebranding support: positioning, mission and program messaging, visual identity, guidelines, and rollout materials.",
    "question": "How does branding help a nonprofit explain its work?",
    "answer": "Nonprofit branding connects your identity with a clear account of your mission, programs, and value to the community. We help define language and visual materials that remain consistent while addressing the different questions participants, partners, volunteers, and supporters bring.",
    "faqs": [
      [
        "Who is this service for?",
        "Community-serving nonprofits with an active mission and a staff team that needs focused communications or technology support. We assess fit around your programs, priorities, team capacity, and budget."
      ],
      [
        "How are fees and timing agreed?",
        "A free discovery call and no-charge assessment help define the work. We agree deliverables, responsibilities, fees, and timing before the engagement starts. The number of audiences, content needs, integrations, and review steps can affect the scope."
      ],
      [
        "Can you work with our existing team and tools?",
        "Yes. We review what your team already uses before recommending changes. Platforms, permissions, staff responsibilities, and any handoff or training are agreed during scoping."
      ],
      [
        "Do you work with nonprofits outside the Hudson Valley?",
        "Yes. Sync Strategic is based in Orange County, NY and serves the Hudson Valley, NYC, and beyond. Remote collaboration is available for organizations outside the region."
      ]
    ],
    "deliverables": [
      "Positioning and mission or program messaging",
      "An agreed visual identity and brand guidelines",
      "Selected website, email, presentation, or print materials",
      "A rollout plan with client reviews and approvals"
    ]
  },
  {
    "slug": "ai-implementation",
    "name": "Practical AI & Automation",
    "benefit": "Give your team more room for the work that matters.",
    "description": "Human-reviewed tools and workflows that reduce repetitive communications tasks and help your team work consistently.",
    "category": "systems",
    "details": "Scoped communications workflows such as drafting content from approved sources, repurposing material, and streamlining routine follow-up. We agree permitted data use, human review, training, and responsibilities before implementation. Clinical decisions, beneficiary eligibility, financial decisions, and sensitive case-management automation are outside this service.",
    "seoTitle": "AI Implementation & Automation for Nonprofit Teams",
    "seoDescription": "Practical AI implementation for nonprofit communications teams. Approved-source content workflows, routine follow-up, staff training, and human review.",
    "question": "Where can a small nonprofit start with AI?",
    "answer": "Start with one repetitive communications task, clear approved sources, and a person responsible for checking the output. Examples include drafting a program update from approved notes or adapting existing content into an email. We assess the task, permitted data, review steps, and staff training before implementation.",
    "faqs": [
      [
        "Who is this service for?",
        "Community-serving nonprofits with an active mission and a staff team that needs focused communications or technology support. We assess fit around your programs, priorities, team capacity, and budget."
      ],
      [
        "How are fees and timing agreed?",
        "A free discovery call and no-charge assessment help define the work. We agree deliverables, responsibilities, fees, and timing before the engagement starts. The number of audiences, content needs, integrations, and review steps can affect the scope."
      ],
      [
        "Can you work with our existing team and tools?",
        "Yes. We review what your team already uses before recommending changes. Platforms, permissions, staff responsibilities, and any handoff or training are agreed during scoping."
      ],
      [
        "Do you work with nonprofits outside the Hudson Valley?",
        "Yes. Sync Strategic is based in Orange County, NY and serves the Hudson Valley, NYC, and beyond. Remote collaboration is available for organizations outside the region."
      ]
    ],
    "deliverables": [
      "A selected workflow and permitted-data boundaries",
      "Configured tools and approved-source instructions",
      "Human-review steps and practical tests",
      "Staff training, documentation, and scoped support"
    ]
  },
  {
    "slug": "impact-communications",
    "name": "Impact Communications & Materials",
    "benefit": "Help people understand the value of your work.",
    "description": "Presentations, program materials, supporter communications, and evidence-based stories that make your work tangible.",
    "category": "story",
    "details": "Program messaging, presentations, one-pagers, impact-report content, campaign materials, and approved stories based on evidence your organization provides. We agree consent and review requirements before using participant stories. Financial reporting, impact evaluation, and grant writing are outside this offer.",
    "seoTitle": "Nonprofit Impact Communications & Program Materials",
    "seoDescription": "Nonprofit impact communications, program materials, presentations, and supporter stories based on approved evidence and participant consent.",
    "question": "What are nonprofit impact communications?",
    "answer": "Impact communications explain the work your organization does and why it matters, using evidence and approved stories. We can help with program one-pagers, presentations, supporter updates, and impact-report content. Your organization supplies and approves the facts; this service does not replace impact evaluation or financial reporting.",
    "faqs": [
      [
        "Who is this service for?",
        "Community-serving nonprofits with an active mission and a staff team that needs focused communications or technology support. We assess fit around your programs, priorities, team capacity, and budget."
      ],
      [
        "How are fees and timing agreed?",
        "A free discovery call and no-charge assessment help define the work. We agree deliverables, responsibilities, fees, and timing before the engagement starts. The number of audiences, content needs, integrations, and review steps can affect the scope."
      ],
      [
        "Can you work with our existing team and tools?",
        "Yes. We review what your team already uses before recommending changes. Platforms, permissions, staff responsibilities, and any handoff or training are agreed during scoping."
      ],
      [
        "Do you work with nonprofits outside the Hudson Valley?",
        "Yes. Sync Strategic is based in Orange County, NY and serves the Hudson Valley, NYC, and beyond. Remote collaboration is available for organizations outside the region."
      ]
    ],
    "deliverables": [
      "A message and evidence brief for the intended audience",
      "Selected program, presentation, or impact-report materials",
      "Consent and review requirements for any participant stories",
      "Approved copy and files for the agreed channels"
    ]
  },
  {
    "slug": "fractional-marketing-leadership",
    "name": "Fractional Marketing Leadership",
    "benefit": "Experienced direction for a team with a lot to carry.",
    "description": "Priorities, planning, and hands-on support for nonprofits that need marketing leadership without adding a full-time role.",
    "category": "systems",
    "details": "Communications planning, internal team guidance, budget recommendations, campaign coordination, scoped delivery, and performance reviews. Responsibilities and capacity are agreed case by case. This engagement supports your executive and development teams without assuming ownership of fundraising or program delivery.",
    "seoTitle": "Fractional Marketing Leadership for Nonprofits",
    "seoDescription": "Fractional marketing leadership for nonprofit teams. Communications planning, priorities, budget recommendations, staff guidance, and scoped hands-on delivery.",
    "question": "What does fractional marketing leadership mean for a nonprofit?",
    "answer": "Fractional marketing leadership gives a nonprofit access to experienced direction for an agreed amount of work without adding a full-time role. We help set priorities, guide communications, coordinate scoped delivery, and review performance alongside your executive and development teams.",
    "faqs": [
      [
        "Who is this service for?",
        "Community-serving nonprofits with an active mission and a staff team that needs focused communications or technology support. We assess fit around your programs, priorities, team capacity, and budget."
      ],
      [
        "How are fees and timing agreed?",
        "A free discovery call and no-charge assessment help define the work. We agree deliverables, responsibilities, fees, and timing before the engagement starts. The number of audiences, content needs, integrations, and review steps can affect the scope."
      ],
      [
        "Can you work with our existing team and tools?",
        "Yes. We review what your team already uses before recommending changes. Platforms, permissions, staff responsibilities, and any handoff or training are agreed during scoping."
      ],
      [
        "Do you work with nonprofits outside the Hudson Valley?",
        "Yes. Sync Strategic is based in Orange County, NY and serves the Hudson Valley, NYC, and beyond. Remote collaboration is available for organizations outside the region."
      ]
    ],
    "deliverables": [
      "Agreed communications priorities and responsibilities",
      "A delivery plan matched to staff and budget capacity",
      "Guidance for your internal team and scoped hands-on work",
      "Progress reports and performance reviews"
    ]
  }
];
export const serviceGroups = [
  {
    "id": "story",
    "name": "Clarify Your Story",
    "description": "Positioning, messaging, branding, and materials that explain your mission."
  },
  {
    "id": "reach",
    "name": "Reach Your Community",
    "description": "Websites and campaigns that connect people with programs and opportunities to help."
  },
  {
    "id": "systems",
    "name": "Connect Your Systems",
    "description": "Relationships, workflows, and practical tools that build your team\u2019s capacity."
  }
];
export const bookingUrl = 'https://calendly.com/syncstrategicdigital-info/30min';
